import React from 'react';
import PropTypes from 'prop-types';
import { Button, SvgIcon } from '@mui/material';
import ShieldCheckmarkIcon from '../../../../icons/shield-checkmark.svg?react';
import { SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY, SESSION_STORAGE_HEALTH_CLASS_KEY, SESSION_STORAGE_TERM_LENGTH_KEY } from '../../../../sessionStorage'
import './ShowOtherOptions.scss';

export default function ShowOtherOptions(props) {

  const href = props.href ? props.href : '/quote/term-life-insurance/multi-carrier-term';
  const title = props.title || "SHOW OTHER OPTIONS";

  const setSessionStorage = (data) => {
    sessionStorage.setItem(SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY, data.coverageAmount);
    sessionStorage.setItem(SESSION_STORAGE_HEALTH_CLASS_KEY, data.healthClass);
    sessionStorage.setItem(SESSION_STORAGE_TERM_LENGTH_KEY, data.terms);
  };

  return (
    <Button
      className={props.termAlternatives ? '' : "other-options-button"}
      fullWidth
      type="submit"
      onClick={() => setSessionStorage(props)}
      href={href}
      variant={props.termAlternatives ? '' : "contained"}
    >
      {props.termAlternatives ? '' : <SvgIcon component={ShieldCheckmarkIcon} color="primary" />}
      <span className={props.termAlternatives ? "primary-color" : "name"}>&nbsp;{title}</span>
    </Button>
  );
}

ShowOtherOptions.propTypes = {
  href: PropTypes.string,
};
